import React from "react";
import {
    Award, BarChart, BarChart2, BarChart3,
    BookOpen, ChartBar,
    ChartLine,
    ClipboardCheckIcon, CogIcon,
    LayoutDashboard,
    LayoutDashboardIcon,
    Library
} from "lucide-react";
import {appRoute} from "../utils/routes";

export const ICON_SIZE = 27

export const sidebarMenus = [
    {
        name: "Dashboard",
        label: "dashboardSidebarLabel",
        route: appRoute(),
        icon: <LayoutDashboard style={{fontSize: ICON_SIZE}}/>
    }, {
        name: "Resources",
        label: "resourcesSidebarLabel",
        route: appRoute("resources"),
        icon: <Library style={{fontSize: ICON_SIZE}}/>
    }, {
        name: "Practice",
        label: "practiceSidebarLabel",
        route: appRoute("practice"),
        icon: <BookOpen style={{fontSize: ICON_SIZE}}/>
    }, {
        name: "Results",
        label: "resultSidebarLabel",
        route: appRoute("results"),
        icon: <BarChart3 style={{fontSize: ICON_SIZE}}/>
    }]